import './RemnantLabel.scss';

import PropTypes from 'prop-types';
import React from 'react';
import Barcode from 'react-barcode';
import QRCode from 'react-qr-code';

import { FourByOneLabel } from '../../labels';
import { TEMPLATE_FIELD_TYPE, FGT_REDIRECT_BASE, ENVIRONMENT } from '../../constants';
import options from '../../utils/options';

const RemnantLabel = (props) => {
    const { part, fields, rows, hashId, colors } = props;

    const { ogPartId } = part;

    let filtered = fields;

    const left = filtered.slice(0, rows);
    const right = filtered.slice(rows, rows * 2);

    const buildValue = (type, value) => {
        switch (type) {
            case TEMPLATE_FIELD_TYPE.BARCODE.value:
                return (<Barcode width={1} height={7} displayValue={false} value={value} margin={0} />);
            // adding the conditional in the case statement renders a url an not a qr code?
            case TEMPLATE_FIELD_TYPE.QR.value:
                // this QRCode module isn't smart enough to not accept undefined 🤦🤷 so we need to filter out any 'undefined' values
                if (value) {
                    return (<QRCode size={66} value={value} />);
                }
                break;
            case TEMPLATE_FIELD_TYPE.IMG.value:
                return (<img src={value} alt={value} />);
            case TEMPLATE_FIELD_TYPE.DATE.value:
                return (<span>{options.getDate(value, TEMPLATE_FIELD_TYPE.DATE.value)}</span>);
            case TEMPLATE_FIELD_TYPE.DATE_TIME.value:
                return (<span>{options.getDate(value, TEMPLATE_FIELD_TYPE.DATE_TIME.value)}</span>);
            default:
                return (<span>{value}</span>);
        }
    };

    const buildField = ({ label, value, type, id }, hashId, pId) => {
        const array = label.split('] - ');

        const isSpeedLink = () => id == 'speed-link' && hashId && pId;

        const fieldValue = isSpeedLink() ? `${FGT_REDIRECT_BASE}/${hashId}/${pId}` : value;

        return (
            <div className={'RemnantLabelField'}>
                <div className={'Label'}>{array[array?.length - 1]}</div>
                <div className={`Value ${type}`}>
                    {buildValue(type, fieldValue)}
                </div>
            </div>
        );
    };

    const RemnantDate = () => (
        <div className='RemnantDate'>
            Printed:
            <br />
            {new Date().toLocaleDateString().split('/').slice(0, 2).join('/')}
        </div >
    );

    const RemnantQrCode = () => (
        <div className='RemnantQrCode'>
            <QRCode size={200} value={`${FGT_REDIRECT_BASE}/${hashId}/${ogPartId}`} />
        </div>
    );

    const RemnantStatusField = () => (
        <div className='RemnantStatusField'>
            STATUS: ___________________
        </div>
    );

    const RemnantColorBand = ({ colors }) => (
        <div className='RemnantColorBand'>
            {colors.map(({ label, style }) => (<div key={label} className={'LabelColorBand'} style={{ ...style }}>{label}</div>))}
        </div>
    );

    const RemnantLabelFields = () => (
        <div className={'RemnantLabelFields'}>
            <div className={'Left'}>
                {left.map((f) => buildField(f, hashId, ogPartId))}
            </div>
            <div className={'Right'}>
                {right.map((f) => buildField(f, hashId, ogPartId))}
            </div>
        </div>
    );

    const RemnantSizeField = () => (
        <div className='RemnantSizeField'>
            REMNANT SIZE: _____ x _____
        </div>
    );

    return ogPartId
        ? (
            <div className='RemnantLabel'>
                {/* first column */}
                <div className='RemnantSideContainer'>
                    <RemnantDate />
                    <RemnantQrCode />
                    {(ENVIRONMENT != 'production') && <p className='PartId'>{part?.id}</p>}
                    <RemnantColorBand colors={colors} />
                    <RemnantLabelFields />
                    <RemnantStatusField />
                    <RemnantSizeField />
                </div>
                {/* second column */}
                <div className='RemnantCenterContainer'>
                    {part &&
                        <div className='FourByOneFieldLabel'>
                            <FourByOneLabel thickBorder {...props} part={{ ...part, id: ogPartId }} fields={fields} renderPartCount={false} />
                        </div>
                    }
                </div>
                {/* third column */}
                <div className='RemnantSideContainer'>
                    <RemnantDate />
                    <RemnantQrCode />
                    <RemnantColorBand colors={colors} />
                    <RemnantLabelFields />
                    <RemnantStatusField />
                    <RemnantSizeField />
                </div>
            </div>
        )
        : (
            <div className='InvalidRemLabel'>
                No Part ID Provided :
            </div>
        );
};

RemnantLabel.defaultProps = {
    part: {},
    fields: [],
    rows: 5,
    hashId: undefined,
    ogPartId: undefined,
    colors: []
};

RemnantLabel.propTypes = {
    part: PropTypes.object,
    fields: PropTypes.array,
    rows: PropTypes.number,
    hashId: PropTypes.string,
    ogPartId: PropTypes.string,
    colors: PropTypes.array
};

export default RemnantLabel;